export default __webpack_public_path__ + "static/media/logo.c55ab282.png";